import { render, staticRenderFns } from "./BaseLabel.vue?vue&type=template&id=5b1b6756&scoped=true&"
import script from "./BaseLabel.vue?vue&type=script&lang=js&"
export * from "./BaseLabel.vue?vue&type=script&lang=js&"
import style0 from "./BaseLabel.vue?vue&type=style&index=0&id=5b1b6756&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1b6756",
  null
  
)

export default component.exports